import { createJSONStorage } from 'zustand/middleware';

// Zustand storage adapter backed by sessionStorage.
// sessionStorage is tab-scoped: data clears when the tab closes, limiting the
// XSS blast radius compared to localStorage for UI preferences.
// Falls back to a no-op adapter in non-browser environments (SSR / Jest without jsdom)
// so that Zustand does not silently fall back to localStorage.
const noopStorage = {
  getItem: (_key: string) => null,
  setItem: (_key: string, _value: string) => {},
  removeItem: (_key: string) => {},
};

export const webSessionStorage =
  typeof window !== 'undefined'
    ? createJSONStorage(() => window.sessionStorage)
    : createJSONStorage(() => noopStorage);
